import React from 'react';
import { Title, translate } from 'react-admin';
import { withStyles } from '@material-ui/core/styles';

const styles = {
  container: {
    padding: 10,
  },
  table: {
    width: "80%",
    fontSize: 24,
  },
};

const ContactsPage = ({ translate, classes, ...props }) => (
    <div className={classes.container}>
        <Title title={translate('staticPages.contacts.name')} />

        <center><table className={classes.table} border="1">
            <tbody>
                <tr>
                    <th colSpan="3">Телефоны сотрудников<br />ТСЖ "Изумрудный"</th>
                </tr>
                <tr>
                    <th>Должность</th>
                    <th>Ф.И.О.</th>
                    <th>Телефон</th>
                </tr>
                <tr>
                    <td>Управляющий</td>
                    <td>Рязанцев Валерий Павлович</td>
                    <td>8-913-739-30-66</td>
                </tr>
                <tr>
                    <td>Офис ТСЖ «Изумрудный»</td>
                    <td></td>
                    <td>8-38341-2-96-47<br />8-913-759-25-25</td>
                </tr>
                <tr>
                    <td>Главный бухгалтер</td>
                    <td>Салагор Татьяна Алексеевна</td>
                    <td>8-38341-2-96-47<br />8-913-759-25-25</td>
                </tr>
                <tr>
                    <td>Специалист по работе с жителями и взысканию задолженности</td>
                    <td>Бурова Ольга Ивановна</td>
                    <td>8-38341-2-96-47<br />8-913-759-25-25</td>
                </tr>
                <tr>
                    <td>Кассир-делопроизводитель</td>
                    <td>Малухина Анастасия Владимировна</td>
                    <td>8-38341-2-96-47<br />8-913-759-25-25</td>
                </tr>
                <tr>
                    <td>Слесарь-сантехник</td>
                    <td>Черный Андрей Николаевич</td>
                    <td>8-953-767-47-19</td>
                </tr>
                <tr>
                    <td>Электрик</td>
                    <td>Балабанов Петр Владимирович</td>
                    <td>8-913-701-14-14</td>
                </tr>
                <tr>
                    <td>Охрана, аварийный диспетчер</td>
                    <td></td>
                    <td>8-913-744-74-05<br />8-913-756-39-08</td>
                </tr>
            </tbody>
        </table>
        <br /><br /> <b>Почта для связи:</b> tsg.izumrudnyi@yandex.ru</center>
    </div>
);

export default translate(withStyles(styles)(ContactsPage));